import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { TextField } from 'material-ui';

class AnnualFixedChargeInput extends Component {
    handleAnnualFixedChange(value) {
        const { setAFixedCharge } = this.props;
        setAFixedCharge(Number(value));
    }

    render() {
        const { aFixedCharge } = this.props;

        return (
            <div>
                <TextField
                    className="TextFields"
                    floatingLabelText="Annual Fixed Charge ($)"
                    hintText="3,000"
                    onChange={(e, value) => this.handleAnnualFixedChange(value)}
                    disabled
                    defaultValue={aFixedCharge}
                />
            </div>
        );
    }
}
AnnualFixedChargeInput.propTypes = {
    aFixedCharge: PropTypes.number.isRequired,
    setAFixedCharge: PropTypes.func.isRequired,
};

export default AnnualFixedChargeInput;



// WEBPACK FOOTER //
// ./src/containers/Inputs/UtilityInputs/AnnualFixedChargeInput/AnnualFixedChargeInput.js